import { Link } from 'react-router-dom';
import { useTitle } from '../lib/useTitle.js';
import { useMetaTags } from '../lib/useMetaTags.js';

export default function NotFound() {
  useTitle('Page Not Found');
  // The SPA rewrite answers unknown URLs with 200, so this is the only
  // signal a crawler gets that the page does not exist.
  useMetaTags({ robots: 'noindex', ogType: undefined });
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: 20 }}>
      <div style={{ textAlign: 'center', maxWidth: 400 }}>
        <div style={{ fontSize: 64, fontWeight: 900, color: 'var(--accent)', marginBottom: 8 }}>404</div>
        <h1 style={{ margin: '0 0 8px', fontSize: 24 }}>Page not found</h1>
        <p style={{ color: 'var(--text-dim)', margin: '0 0 24px' }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <Link to="/" style={{ padding: '12px 24px', background: 'var(--accent)', color: 'var(--bg)', borderRadius: 'var(--radius-md)', textDecoration: 'none', fontWeight: 600 }}>
            Go home
          </Link>
          <Link to="/login" style={{ padding: '12px 24px', border: '1px solid var(--border)', borderRadius: 'var(--radius-md)', textDecoration: 'none', color: 'var(--text-dim)' }}>
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
